import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import LeaveResultBox from "../../../OrganizationDefinitions/CreateUserAccount/Components/TabItems/Leave/components/LeaveResultBox";

function DisplayLeaveItem({ day, hours }) {
  const theme = useTheme().palette.mode;
  return (
    <Box
      sx={{
        bgcolor: theme === "dark" ? "rgb(22, 27, 37)" : "#F7FBFF",
        border:theme === "dark" ? "1px solid rgb(22, 27, 37)"  : "1px solid #E6F1FF",
        borderRadius: "4px",
        padding: "4px",
        display: "flex",
        alignItems: "center",
        flex: 1,
      }}
    >
      <Typography> روزانه :</Typography>
      <LeaveResultBox>{day}</LeaveResultBox>
      <Typography> ساعتی :</Typography>
      <LeaveResultBox>{hours}</LeaveResultBox>
    </Box>
  );
}

export default DisplayLeaveItem;
